import { useQuery } from '@tanstack/react-query';

import { taxReturnService } from '../services/taxReturn.service';

export const useTaxReturnHeader = () => {
  return useQuery({
    queryKey: ['tax-return-header'],
    queryFn: () => taxReturnService.getTaxReturnHeader()
  });
};
